import moment from 'moment'
import { Redirect } from 'react-router'

import { getDateFormat, createPath, withLanguage } from 'i18n/utils'
import { queryNews } from 'wordpress/actions'
import { Image } from 'wordpress/components'
import Meta from 'shared/components/Meta'

import { newsItemSlugSelector, newsItemSelector, categorySelector } from '../selectors'
import { branch, renderComponent, renderNothing } from 'recompose'
import { loadOnMount } from 'shared/hoc'

const RedirectToActualLanguage = ({ language, newsItem }) => (
    <Redirect replace to={createPath(language, `/news/uncategorized/${newsItem.translations[language]}`)} />
)

const SingleNewsItem = ({ newsItem }) => {
    const { title, image, date, content } = newsItem
    const formattedDate = moment(date).format(getDateFormat())
    const html = { __html: content }
    return (
        <div className="single">
            <Meta {...newsItem} />

            <div className="date">
                <span>
                    <i className="category icon-4" />
                    <T>news.label.published</T> {formattedDate}
                </span>
            </div>
            <div className="content" dangerouslySetInnerHTML={html} />
            <div className="image">
                <Image image={image} title={title} />
            </div>
        </div>
    )
}

export default compose(
    withLanguage,
    connect(
        createStructuredSelector({
            category: categorySelector,
            slug: newsItemSlugSelector,
            newsItem: newsItemSelector,
        }),
        { queryNews }
    ),
    loadOnMount('queryNews', ({ slug }) => [{ slug }]),
    branch(props => !props.newsItem, renderNothing),
    branch(
        ({ language, slug, newsItem }) => newsItem.translations[language] !== slug,
        renderComponent(RedirectToActualLanguage)
    )
)(SingleNewsItem)
